import { render, staticRenderFns } from "./EventsAdd.vue?vue&type=template&id=39c1c8c0"
import script from "./EventsAdd.vue?vue&type=script&lang=js"
export * from "./EventsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports